// import '@rainbow-me/rainbowkit/styles.css';
import { getDefaultWallets } from '@rainbow-me/rainbowkit';
import { getDefaultClient } from 'connectkit';
import { chain, configureChains, createClient } from 'wagmi';
import { getDefaultProvider } from 'ethers';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';
import { infuraProvider } from 'wagmi/providers/infura';
import { ChainId } from '@thirdweb-dev/sdk';

const alchemyId = process.env.REACT_APP_ALCHEMY_ID;
// const alchemyId = 'I8USnwrVUfU-43G7RSqFMwafLMmX_pl9';
const infuraId = '0f0dd72a93d346d7a0a623685eadffae';
export const { chains, provider } = configureChains(
  // [chain.goerli],
  [chain.polygonMumbai, chain.polygon],
  [infuraProvider({ apiKey: infuraId })],
  [alchemyProvider({ apikey: alchemyId })]
);

export const active = ChainId.Mumbai;

export const wagmiClient = createClient(
  getDefaultClient({
    autoConnect: true,
    appName: 'Septagon',
    provider,
  })
);

console.log(alchemyId, 'alchemyId');
